"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DefaultBrandColors = {
    brand: "#2980b9",
    complementary: "#34495e",
    extra: [],
};
exports.default = DefaultBrandColors;
